import {
  controlSectionsVulcan,
  monitorSectionsVulcan,
  protectSectionsVulcan,
  secureBusinessPlanVulcan
} from '../../../utils/constant';
import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { pricingFields, setPricingFields } from './secureBusinessFieldNames';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

export const handleInstallationFeeDiscount = (fields, numberOfEquipments) => {
  const locale = getLocale();
  const {
    vulcanWebform: { vulWaivedInstallationFeeOptionTSB }
  } = locale === 'en-US' ? EN : FR;
  const { options, value } = fields;

  // SOF-2981: Add the following logic based on number of additional equipment selected.
  // These are discounts on the installation fee.
  // If 0 additional devices - remove $350 from one time total
  // If 1-3 additional devices - remove $250 from one time total
  // If 4-10 additional devices - remove $150 from one time total
  // If 11+ no discount should apply
  const getInstallationFeeDiscount = (qty) => {
    if (qty === 0) return 350;
    if (qty > 0 && qty < 4) return 250;
    if (qty > 3 && qty < 11) return 150;
    return 0;
  };

  // Delete previous Installation Fee offer
  const installationFeeOptionIndex = options.findIndex((option) => option.fields.value === vulWaivedInstallationFeeOptionTSB);
  if (installationFeeOptionIndex > -1) {
    options.splice(installationFeeOptionIndex, 1);
    if (Array.isArray(value)) {
      const installationFeeIndex = value.findIndex((i) => i === vulWaivedInstallationFeeOptionTSB);
      if (installationFeeIndex > -1) {
        value.splice(installationFeeIndex, 1);
      }
    }
  }

  // Add new Installation Fee offer
  const installationFeeDiscount = getInstallationFeeDiscount(numberOfEquipments);
  if (installationFeeDiscount > 0) {
    options.push({
      fields: {
        label: `$${installationFeeDiscount} ${vulWaivedInstallationFeeOptionTSB}`,
        value: vulWaivedInstallationFeeOptionTSB,
        oneTimePrice: -1 * installationFeeDiscount,
        disabledOption: true
      }
    });
    if (Array.isArray(value)) {
      const installationFeeIndex = value.findIndex((i) => i === vulWaivedInstallationFeeOptionTSB);
      if (installationFeeIndex === -1) {
        value.push(vulWaivedInstallationFeeOptionTSB);
      }
    }
  }
};

export const getSecureBusinessTotals = (formFields, orderData) => {
  const locale = getLocale();
  const {
    vulcanWebform: { vulMonitorTSB, vulControlTSB, vulProtectTSB }
  } = locale === 'en-US' ? EN : FR;

  setPricingFields(formFields);
  if (
    formFields[secureBusinessPlanVulcan] &&
    formFields[secureBusinessPlanVulcan].value === vulMonitorTSB
  ) {
    monitorSectionsVulcan.forEach(section => {
      formFields = { ...formFields, ...formFields[section] };
    });
  } else if (
    formFields[secureBusinessPlanVulcan] &&
    formFields[secureBusinessPlanVulcan].value === vulProtectTSB
  ) {
    protectSectionsVulcan.forEach(section => {
      formFields = { ...formFields, ...formFields[section] };
    });
  } else if (
    formFields[secureBusinessPlanVulcan] &&
    formFields[secureBusinessPlanVulcan].value === vulControlTSB
  ) {
    controlSectionsVulcan.forEach(section => {
      formFields = { ...formFields, ...formFields[section] };
    });
  }

  const secureBusinessTotals = getTotalsForSetOfTotals(
    pricingFields,
    formFields,
    orderData
  );

  return secureBusinessTotals;
};

export const getSecureBusinessPriceSelections = formFields => {
  return priceSelectionList(pricingFields, formFields);
};
